import React from 'react';
import WebhooksAccessLayout from '../../../components/WebhooksAccessLayout';
import { READ_AUDIT_LOGS } from '../../../constants/webhookPermissions';

export default function AuditLogsAccessLayout() {
  return <WebhooksAccessLayout title="Audit Log" permission={READ_AUDIT_LOGS} />;
}
